export default __webpack_public_path__ + "static/Денежный поток-62a73ee6e6aca630e92248ddd64dd74e.jpg";